var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'WhereFilter',
        label: 'ID',
        attributes: 'user_id'
      },
      {
        type: 'WhereLikeFilter',
        label: 'E-Mail-Adresse',
        attributes: 'user.email'
      },
      {
        type: 'WhereLikeFilter',
        label: 'Name',
        attributes: 'user.name'
      },
      {
        id: 0,
        type: 'SelectFilter',
        label: 'Agentur',
        options: _vm.agencyOptions,
        attributes: 'agency_id'
      }
    ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/moderator","filter":_vm.filter,"appends":['last_login_ip_and_country', 'last_ping'],"additionalRequestData":{ hidden: ['in', 'out'] },"row-classes":{
      'table-warning': model => {
        return Boolean(model.user && model.user.disabled_at);
      },
      'table-danger': model => {
        return Boolean(model.deleted_at);
      }
    },"attributes":[
      {
        attribute: 'user.id',
        name: 'ID',
        sortable: false
      },
      {
        name: 'Moderator',
        type: 'UserNoEmailCell',
        attribute: 'user',
        sortable: false
      },
      {
        name: 'Letzter Login von',
        attribute: 'last_login_ip_and_country',
        type: 'IpCell',
        sortable: false
      },
      {
        attribute: 'user.id',
        name: 'Aktiv',
        type: 'OnlineCell',
        sortable: false
      },
      {
        name: 'Letzte Aktivität',
        attribute: 'last_activity',
        type: 'DateTimeCell'
      },
      {
        attribute: 'agency.name',
        name: 'Agentur',
        sortable: false
      },
      {
        name: 'Aktionen',
        type: 'ModeratorActionCell'
      },
      {
        name: 'Ping',
        type: 'PingCell',
        attribute: 'last_ping'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }